module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAAXNSR0IArs4c6QAAAFRJREFUCB1ty0sKgDAMhOEUwWUX6t77X0kKXsCFDwTRtvqP0I048EEmJM7MenT4y1Sx3eBRfy52+qiDGwsaqCsXBqSyyBR9tFACDg3lQPOJiBUz3jxU6BCRdy83hAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/v2/sort-down.png
// module id = 177
// module chunks = 33